import type { RouteObject } from 'react-router-dom';

import { defineHandle } from '@/app/routes/types';

import { ordersAccessRoles } from './access';
import { OrderDetailPage } from './pages/OrderDetailPage';
import { OrderManagementPage } from './pages/OrderManagementPage';

export const ordersRoutes: RouteObject[] = [
  {
    path: 'orders',
    element: <OrderManagementPage />,
    handle: defineHandle({
      roles: [...ordersAccessRoles],
      breadcrumb: 'breadcrumb.home',
      title: 'common:nav.orders',
    }),
  },
  {
    path: 'orders/:orderId',
    element: <OrderDetailPage />,
    handle: defineHandle({
      roles: [...ordersAccessRoles],
      breadcrumb: 'breadcrumb.home',
      title: 'common:nav.orders',
    }),
  },
];
